module.exports = __webpack_public_path__ + "static/logo2-694098141f356924f90bb92b9217b0d3.jpg";